module.exports = __webpack_public_path__ + "img/Willow.0f8f00a.svg";